import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth.js';

/**
 * @graph-node {Page}
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business aC Men's Hub のダッシュボードトップ。ログイン中メンバーを迎える歓迎画面。機能は実装され次第このHubに追加される。
 * @graph-connects useAuth [calls] 現在ユーザー取得
 */
export function DashboardHomePage() {
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="mx-auto w-full max-w-3xl px-4 py-10">
      <div className="mb-1 font-mono text-xs tracking-widest text-[var(--color-accent-primary)] uppercase">
        {t('app.name')}
      </div>
      <h1 className="text-2xl font-bold text-[var(--color-text-primary)]">
        {user?.name ? t('dashboard.welcomeUser', { name: user.name }) : t('dashboard.welcome')}
      </h1>
      <p className="mt-3 text-sm leading-relaxed text-[var(--color-text-secondary)]">
        {t('dashboard.description')}
      </p>
      <p className="mt-2 text-sm leading-relaxed text-[var(--color-text-secondary)]">
        {t('dashboard.comingSoon')}
      </p>
    </div>
  );
}
